import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/birthday-gifts/log")({
  component: lazyRouteComponent(() => import("./-pages/admin.birthday-gifts.log")),
});
